<template>
  <div class="app-survey-stepper">
    <div class="app-survey-stepper__content">
      <slot :step="step" :steps="steps" :is-first="isFirstStep" :is-last="isLastStep" :previous-step="previousStep" :next-step="nextStep" />
    </div>
    <div v-show="!hideControlsForSteps.includes(step)" class="app-survey-stepper__controls">
      <slot
        name="controls"
        :nextStep="nextStep"
        :previousStep="previousStep"
        :step="step"
        :steps="steps"
        :hideControlsForSteps="hideControlsForSteps"
        :isFirstStep="isFirstStep"
        :isLastStep="isLastStep"
      >
        <gg-btn text :disabled="isFirstStep || loading" @click="previousStep">
          <v-icon left small>mdi-chevron-left</v-icon>
          {{ backLabel }}
        </gg-btn>
        <span>
          Step {{ step + 1 - hideControlsForSteps.length }} of {{ steps - hideControlsForSteps.length }}
        </span>
        <gg-btn v-show="!isLastStep" text :disabled="loading" @click="nextStep">
          {{ nextLabel }}
          <v-icon right small>mdi-chevron-right</v-icon>
        </gg-btn>
        <gg-btn v-show="isLastStep" :loading="loading" @click="$emit('finish')">
          {{ finishLabel }}
        </gg-btn>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppSurveyStepper',
  model: {
    event: 'change',
    prop: 'step'
  },
  props: {
    steps: {
      type: Number,
      required: true
    },
    step: {
      type: Number,
      required: true
    },
    hideControlsForSteps: {
      type: Array,
      default: () => []
    },
    finishLabel: {
      type: String,
      default: 'Finish'
    },
    nextLabel: {
      type: String,
      default: 'Next'
    },
    backLabel: {
      type: String,
      default: 'Back'
    },
    loading: {
      type: Boolean,
      default: false
    },
  },
  provide () {
    return {
      surveyStepper: this,
    }
  },
  computed: {
    isFirstStep () {
      return this.step === 0
    },
    isLastStep () {
      return this.step === this.steps - 1
    }
  },
  methods: {
    nextStep () {
      if (this.step < this.steps - 1) {
        this.$emit('change', this.step + 1)
      }
    },
    previousStep () {
      if (this.step > 0) {
        this.$emit('change', this.step - 1)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.app-survey-stepper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  &__content {
    flex: 1;
    width: 100%;
    margin-bottom: 1rem;
  }
  &__controls {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
}
</style>
